import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import * as PopoverPrimitive from '@radix-ui/react-popover';
import { cn } from '../lib/utils.js';
/**
 * Popover — Radix Popover exposed as compound parts (Popover / PopoverTrigger /
 * PopoverContent / PopoverClose / PopoverAnchor) so callers compose their own
 * body: MarketRow detail panels, column/filter menus, row overflow actions.
 * `PopoverContent` is themed and portalled and forwards its ref + props.
 */
export const Popover = PopoverPrimitive.Root;
export const PopoverTrigger = PopoverPrimitive.Trigger;
export const PopoverAnchor = PopoverPrimitive.Anchor;
export const PopoverClose = PopoverPrimitive.Close;
export const PopoverContent = forwardRef(function PopoverContent({ className, align = 'start', sideOffset = 6, ...props }, ref) {
    return (_jsx(PopoverPrimitive.Portal, { children: _jsx(PopoverPrimitive.Content, { ref: ref, align: align, sideOffset: sideOffset, className: cn('z-[110] min-w-[200px] rounded-card border-[0.5px] border-line-strong bg-surface p-2 shadow-card outline-none', 'font-ui text-[13px] leading-[1.5] text-ink', className), ...props }) }));
});
//# sourceMappingURL=popover.js.map